import React, { useEffect, useState } from "react";
import SimpleDialog from "../../Dialogs/SimpleDialog";
import NuevaFacturacion from "../NuevaFacturacion";
import { UrlApi } from "../../../services/apirest";
import * as api from "../api";
import { deEnvasadoPedidoARemito } from "../helpers";

// Facturacion puntual de un remito que proviene de un pedido de envasado
// (envasado_pedidos.estado = 354). Resuelve el cliente facturador (facturar_a),
// convierte los renglones del pedido a la forma de "remito con items" y abre
// NuevaFacturacion en el mismo camino que un remito puntual de granel.
function DialogNuevaFactEnvasadoContainer({ open, setOpen, row }) {
  const [dataCliente, setDataCliente] = useState();
  const [dataRemito, setDataRemito] = useState(null);
  const [letra, setLetra] = useState();

  const cargarDatos = async () => {
    const clienteRes = await fetch(
      `${UrlApi}/envasado_clientes/facturar/${row.facturar_a}`
    ).then((d) => d.json());
    const clienteFact = Array.isArray(clienteRes) ? clienteRes[0] : null;
    if (!clienteFact) return;
    setDataCliente(clienteFact);

    const renglones = await fetch(
      `${UrlApi}/envasado_pedidos_renglon/renglonesremito-pedido/${row.id_envasado_pedido}`
    ).then((d) => d.json());
    const remito = deEnvasadoPedidoARemito(
      Array.isArray(renglones) ? renglones : [],
      clienteFact.id_empresa
    );
    setDataRemito(remito);

    if (clienteFact.situacion_iva) api.getLetra(clienteFact.situacion_iva, setLetra);
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  const Children = (
    <>
      {dataCliente && dataRemito && letra && (
        <NuevaFacturacion
          origen={"listadoRemitos"}
          dataCliente={dataCliente}
          pedidosCliente={dataRemito}
          rowSelection={{ 0: true }}
          letra={letra}
        />
      )}
    </>
  );

  return (
    <div>
      <SimpleDialog
        width="xl"
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        titulo={`Facturar remito a: ${dataCliente?.razon_social}`}
        subtitulo={`Remito N° ${row.nro_remito}`}
        children={Children}
      />
    </div>
  );
}

export default DialogNuevaFactEnvasadoContainer;
